module.exports = __webpack_public_path__ + "static/media/22ESCWA9.b012129b.jpg";